import axios from "axios";

export const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_BASE_URL,
});
// login
export const login = async (formData) => {
  const res = await api.post(`/admin/login`, formData);
  return res;
};

// forget password
export const forgotPassword = async (formData) => {
  const res = await api.post(`/admin/forgotpassword`, formData);
  return res;
};

// change password
export const changePassword = async (id, token, formData) => {
  const res = await api.post(`/admin/forget-password/${id}/${token}`, formData);
  return res;
};

// resources page
export const getAllBlogs = async () => {
  const res = await api.get(`/resources/getAllBlogs`);
  return res;
};

export const getAllBlogsByPartner = async (partnerId) => {
  const res = await api.get(`/resources/getAllBlogsByPartner/${partnerId}`);
  return res;
};

export const getBlogsById = async (id) => {
  const res = await api.get(`/resources/getResourcesById/${id}`);
  return res;
};

export const updateBlogsById = async (id, formData) => {
  const res = await api.put(`/resources/update/${id}`, formData);
  return res;
};

export const createNewBlog = async (formData) => {
  const res = await api.post(`/resources/create`, formData);
  return res;
};
export const createMeetTheTeam = async (formData) => {
  const res = await api.post(`/abouteUsTeamSectionNew/createTeamSection`, formData);
  return res;
};

export const deleteBlogById = async (id) => {
  const res = await api.delete(`/resources/delete/${id}`);
  return res;
};

export const deleteMeetTheTeam = async (id) => {
  const res = await api.delete(`/abouteUsTeamSectionNew/deleteTeamSection/${id}`);
  return res;
};

//Document Setting
export const getDocumentsCategory = async (partnerId) => {  
  const res = await api.get(`/category/get-all-category/${partnerId}`);
  return res;
};

export const createDocumentsCategory = async (body) => {
  const res = await api.post(`/category/create-category`,body);
  return res;
};

export const updateDocumentsCategory = async ({id, ...body}) => {
  const res = await api.put(`/category/update-category/${id}`,body);
  return res;
};

export const DeleteDocumentsCategory = async (id) => {
  const res = await api.delete(`/category/delete-category/${id}`);
  return res;
};

export const createDocumentsSubCategory = async (body) => {
  const res = await api.post(`/sub-category/create-sub-category`,body);
  return res;
};

export const DeleteDocumentsSubCategory = async (id) => {
  const res = await api.delete(`/sub-category/delete-sub-category/${id}`);
  return res;
};

export const updateDocumentsSubCategory = async ({id, ...body}) => {
  const res = await api.put(`/sub-category/update-sub-category/${id}`,body);
  return res;
};

export const updateCategoryOrder = async (categories) => {
  const res = await api.put(`/category/update-category-order`, { categories });
  return res;
};

export const updateSubCategoryOrder = async (sub_categories) => {
  const res = await api.put(`/sub-category/update-sub-category-order`, { sub_categories });
  return res;
};


// contact us page
export const getAllContacts = async () => {
  const res = await api.get(`/contactUs/getAllContacts`);
  return res;
};
export const getAllContactsByPartner = async (partnerId) => {
  const res = await api.get(`/contactUs/getAllContactsByPartner/${partnerId}`);
  return res;
};

export const getAllPartners = async () => {
  const res = await api.get(`/partner/getAllPartners`);
  return res;
};
export const getAllPartnerById = async (id) => {
  const res = await api.get(`/partner/getAllPartnerById/${id}`);
  return res;
};
export const createPartner = async (body) => {
  const res = await api.post(`/partner/createPartner`, body);
  return res;
};
export const updatePartnerColorById = async (id, body) => {
  const res = await api.post(`/partner/updatePartnerById/${id}`, body);
  return res;
};

export const setPartnerStatus = async (id, status) => {
  const res = await api.post(`/partner/setPartnerStatus/${id}`, { status });
  return res;
};
export const getcontactUsById = async (id) => {
  const res = await api.get(`/contactUs/getcontactUsById/${id}`);
  return res;
};

// home page
export const getAllHomeHeader = async (partnerId) => {
  const res = await api.get(`/home/getAllHomeHeader/${partnerId}`);
  return res;
};

export const getHomeHeader = async (id) => {
  const res = await api.get(`/home/getHomeHeaderById/${id}`);
  return res;
};

export const updateContactUs = async (id, formData) => {
  const res = await api.put(`/contactUs/update/${id}`, formData);
  return res;
};

export const updateHomeHeader = async (id, formData) => {
  const res = await api.put(`/home/updateHomeHeader/${id}`, formData);
  return res;
};

export const createHomeHeader = async (formData) => {
  const res = await api.post(`/home/createHomeHeader`, formData);
  return res;
};

export const getAllHomeSlider1 = async (partnerId) => {
  const res = await api.get(`/home/getAllHomeSliderOne/${partnerId}`);
  return res;
};

export const getHomeSlider1 = async (id) => {
  const res = await api.get(`/home/homeSliderOneById/${id}`);
  return res;
};

export const updateHomeSlider1 = async (id, formData) => {
  const res = await api.put(`/home/updateHomeSliderOne/${id}`, formData);
  return res;
};

export const createHomeSlider1 = async (formData) => {
  const res = await api.post(`/home/createHomeSliderOne`, formData);
  return res;
};

export const getAllHomeSlider2 = async (partnerId) => {
  const res = await api.get(`/home/getAllHomeSliderTwo/${partnerId}`);
  return res;
};

export const getHomeSlider2 = async (id) => {
  const res = await api.get(`/home/homeSliderTwoById/${id}`);
  return res;
};

export const updateHomeSlider2 = async (id, formData) => {
  const res = await api.put(`/home/updateHomeSliderTwo/${id}`, formData);
  return res;
};
export const createHomeSlider2 = async (formData) => {
  const res = await api.post(`/home/createHomeSliderTwo`, formData);
  return res;
};

export const getAllHomeParagraph = async (partnerId) => {
  const res = await api.get(`/home/getAllHomeParagraph/${partnerId}`);
  return res;
};

export const getHomeParagraph = async (id) => {
  const res = await api.get(`/home/getHomeParagraphById/${id}`);
  return res;
};

export const updateHomeParagraph = async (id, formData) => {
  const res = await api.put(`/home/updateHomeParagraph/${id}`, formData);
  return res;
};

export const createHomeParagraph = async (formData) => {
  const res = await api.post(`/home/createHomeParagraph`, formData);
  return res;
};

export const getAllHomeOverview = async (partnerId) => {
  const res = await api.get(`/home/getAllHomeService/${partnerId}`);
  return res;
};

export const getHomeOverview = async (id) => {
  const res = await api.get(`/home/getHomeServiceById/${id}`);
  return res;
};

export const updateHomeOverview = async (id, formData) => {
  const res = await api.put(`/home/updateHomeService/${id}`, formData);
  return res;
};

export const createHomeOverview = async (formData) => {
  const res = await api.post(`/home/createHomeService`, formData);
  return res;
};

//button
export const getAllButton = async () => {
  const res = await api.get(`/button/getAllButton`);
  return res;
};

//create button
export const createButton = async (data) => {
  const res = await api.post(`/button/createButton`, data);
  return res;
};

export const getAllButtonByPartner = async (partnerId) => {
  const res = await api.get(`/button/getAllButtonByPartner/${partnerId}`);
  return res;
};

export const getButton = async (id) => {
  const res = await api.get(`/button/getButtonById/${id}`);
  return res;
};

export const updateButton = async (id, formData) => {
  const res = await api.put(`/button/updateButton/${id}`, formData);
  return res;
};

// Footer
export const getFooterById = async (id) => {
  const res = await api.get(`/footer/getFooterById/${id}`);
  return res;
};
// Footer
export const getFooterByPartnerId = async (partnerId) => {
  const res = await api.get(`/footer/getFooterByPartner/${partnerId}`);
  return res;
};

export const updateFooter = async (id, formData) => {
  const res = await api.put(`/footer/updateFooter/${id}`, formData);
  console.log(res.data);
  return res;
};

export const createFooter = async (formData) => {
  const res = await api.post(`/footer/createFooter`, formData);
  console.log(res.data);
  return res;
};
//Admin
export const getAllAdmin = async () => {
  const res = await api.get("/admin/getAllAdmin", {
    headers: {
      Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOnsiaWQiOjksImFkbWluX25hbWUiOiJjaGludGhhbmkiLCJlbWFpbCI6Im5jcmFua290aEBnbWFpbC5jb20iLCJzdGF0dXMiOiJBRE1JTiJ9LCJpYXQiOjE2NzgzNTI2NzU0NTksImV4cCI6MTY3ODM1Mzg4NTA1OX0.BvOIUYX-mSMQ4Kt4ckaX3yzTs-gLmJQhRqjiKTxggEw"}`,
    },
  });
  
  return res.data;
};

export const deleteadminById = async (id) => {
  const res = await api.delete(`/admin/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOnsiaWQiOjksImFkbWluX25hbWUiOiJjaGludGhhbmkiLCJlbWFpbCI6Im5jcmFua290aEBnbWFpbC5jb20iLCJzdGF0dXMiOiJBRE1JTiJ9LCJpYXQiOjE2NzgzNTI2NzU0NTksImV4cCI6MTY3ODM1Mzg4NTA1OX0.BvOIUYX-mSMQ4Kt4ckaX3yzTs-gLmJQhRqjiKTxggEw"}`,
    },
  });
  return res;
};

// export const updateAdminById = async (id, formData) => {
//     const res = await api.put(`/admin/update/${id}`, formData)
//     
//     return res
// }

// export const updateAdminById = async (id, formData) => {
//     // const token = localStorage.getItem('token');
//     const config = {
//       headers: {
//         Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOnsiaWQiOjgsImFkbWluX25hbWUiOiJzYWppdGgiLCJlbWFpbCI6InNhaml0aHRoaWxhbmdhOTRAZ21haWwuY29tIiwic3RhdHVzIjoiQURNSU4ifSwiaWF0IjoxNjc4NDAzMjcxMzY3LCJleHAiOjE2Nzg0MDQ0ODA5Njd9.CCofKhzt6O2MEZnBBaIknFFvAOAmC2p1YSBv6YFDgsg"}`,
//       },
//     };
//     const res = await api.put(`/admin/update/${id}`, formData, config)
//     // 
//     // 
//     return res
//   }

export const updateAdminById = async (id, formData) => {
  // const token = localStorage.getItem('token');
  const config = {
    headers: {
      Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOnsiaWQiOjgsImFkbWluX25hbWUiOiJzYWppdGgiLCJlbWFpbCI6InNhaml0aHRoaWxhbmdhOTRAZ21haWwuY29tIiwic3RhdHVzIjoiQURNSU4ifSwiaWF0IjoxNjc4NDAzMjcxMzY3LCJleHAiOjE2Nzg0MDQ0ODA5Njd9.CCofKhzt6O2MEZnBBaIknFFvAOAmC2p1YSBv6YFDgsg"}`,
    },
  };
  const res = await api.put(`/admin/update/${id}`, formData, config, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res;
};

export const getAdminById = async (id) => {
  const res = await api.get(`/admin/getAdmin/${id}`, {
    headers: {
      Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOnsiaWQiOjgsImFkbWluX25hbWUiOiJzYWppdGhBQkMiLCJlbWFpbCI6InNhaml0aHRoaWxhbmdhOTRAZ21haWwuY29tIiwic3RhdHVzIjoiQURNSU4ifSwiaWF0IjoxNjc4NDAwMzE4OTg2LCJleHAiOjE2Nzg0MDE1Mjg1ODZ9.b-SX3Qy3IYVFfXIbPgmRoSPLre-UWlevt-4VprJUUSc"}`,
    },
  });
  return res;
};

// export const getAdminById = async (id, token) => {
//     const res = await api.get(`/admin/getAdmin/${id}`, {
//         headers: {
//             Authorization: `Bearer ${token}`
//         }
//     })
//     return res
// }

// export const createNewAdmin = async (formData) => {
//     const res = await api.post(`/admin/register`, formData,  {
//         headers: {
//             Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOnsiaWQiOjgsImFkbWluX25hbWUiOiJzYWppdGhBQkMiLCJlbWFpbCI6InNhaml0aHRoaWxhbmdhOTRAZ21haWwuY29tIiwic3RhdHVzIjoiQURNSU4ifSwiaWF0IjoxNjc4NDAwMzE4OTg2LCJleHAiOjE2Nzg0MDE1Mjg1ODZ9.b-SX3Qy3IYVFfXIbPgmRoSPLre-UWlevt-4VprJUUSc"}`
//         }
//     })
//     
//     return res
// }

export const createNewAdmin = async (formData) => {
  const res = await api.post(`/admin/register`, formData);
  
  return res;
};

// ForBusiness
export const getForBusinessCard = async (id) => {
  const res = await api.get(`/business/getBusinessCardById/${id}`);
  return res;
};
export const updateForBusinessCard = async (id,formData) => {
  const res = await api.put(`/business/updateBusinessCard/${id}`, formData);
  return res;
};
export const createForBusinessCard = async (formData) => {
  const res = await api.post(`/business/createBusinessCard`, formData);
  return res;
};

export const getForBusinessImage = async (id) => {
  const res = await api.get(`/business/getBusinessHeaderById/${id}`);
  return res;
};
export const updateForBusinessImage = async (id,formData) => {
  const res = await api.put(`/business/updateBusinessHeader/${id}`, formData);
  return res;
};

export const createForBusinessImage = async (formData) => {
  const res = await api.post(`/business/createBusinessHeader`, formData);
  return res;
};

export const getBusinessBottom = async (id) => {
  const res = await api.get(`/business/getByIdBusinessFooter/${id}`);
  return res;
};

export const updateBusinessBottom = async (id, formData) => {
  const res = await api.put(`/business/updateBusinessFooter/${id}`, formData);
  return res;
};
export const createBusinessBottom = async (formData) => {
  const res = await api.post(`/business/createBusinessFooter`, formData);
  return res;
};

export const updateMeetTheTeam = async (id, formData) => {
  const res = await api.put(`/abouteUsTeamSectionNew/updateTeamSection/${id}`, formData);
  return res;
};

export const getAllBusinessParagraph = async (partnerId) => {
  const res = await api.get(`/business/getAllBusinessParagraph/${partnerId}`);
  return res;
};
export const getAllBusinessHeader = async (partnerId) => {
  const res = await api.get(`/business/getAllBusinessHeader/${partnerId}`);
  return res;
};
export const getAllBusinessCardData = async (partnerId) => {
  const res = await api.get(`/business/getAllBusinessCardData/${partnerId}`);
  return res;
};
export const getByPartnerIdBusinessFooter = async (partnerId) => {
  const res = await api.get(`/business/getByPartnerIdBusinessFooter/${partnerId}`);
  return res;
};

export const getBusinessParagraph = async (id) => {
  const res = await api.get(`/business/getByIdBusinessParagraph/${id}`);
  return res;
};

export const getByMeetTheTeam = async (id) => {
  const res = await api.get(`/abouteUsTeamSectionNew/getByIdTeamSection/${id}`);
  return res;
};

export const updateBusinessParagraph = async (id, formData) => {
  const res = await api.put(
    `/business/updateBusinessParagraph/${id}`,
    formData
  );
  return res;
};

export const createBusinessParagraph = async (formData) => {
  const res = await api.post(
    `/business/createBusinessParagraph`,
    formData
  );
  return res;
};
// ForIndividuals
export const getForIndividualsStep = async () => {
  const res = await api.get(`/forIndividuals/getStepById/1`);
  return res;
};
export const updateForIndividualsStep = async (formData) => {
  const res = await api.put(`/forIndividuals/updateStep/1`, formData);
  return res;
};
export const getForIndividualsPara = async (id) => {
  const res = await api.get(`/forIndividuals/getByParagraph/${id}`);
  return res;
};

export const getAllForIndividualsParaView = async (partnerId) => {
  const res = await api.get(`/forIndividuals/getAllForIndividualsParaView/${partnerId}`);
  return res;
};
export const getAllForIndividualsStepView = async (partnerId) => {
  const res = await api.get(`/forIndividuals/getAllForIndividualsStepView/${partnerId}`);
  return res;
};

export const getAllForIndividualsCommentsView = async (partnerId) => {
  const res = await api.get(`/forIndividuals/getAllForIndividualsCommentsView/${partnerId}`);
  return res;
};

export const updateForIndividualsPara = async (id,formData) => {
  const res = await api.put(`/forIndividuals/updateParagraph/${id}`, formData);
  return res;
};
export const createForIndividualsPara = async (formData) => {
  const res = await api.post(`/forIndividuals/createParagraph`, formData);
  return res;
};

export const getForIndividualsComment = async (id) => {
  const res = await api.get(`/forIndividuals/getCommentById/${id}`);
  return res;
};
export const updateForIndividualsComment = async (id, formData) => {
  const res = await api.put(`/forIndividuals/updateComment/${id}`, formData);
  return res;
};
export const  createForIndividualsComment = async (formData) => {
  const res = await api.post(`/forIndividuals/createComment`, formData);
  return res;
};
//About Us
export const getAboutUsHeader = async (id) => {
  const res = await api.get(`/abouteUsHeader/getById/${id}`);
  return res;
};

export const getAllAboutUsHeaderView = async (partnerId) => {
  const res = await api.get(`/abouteUsHeader/getByPartner/${partnerId}`);
  return res;
};
export const getAllAboutUsParagraphView = async (partnerId) => {
  const res = await api.get(`/abouteUsParagraph/getByPartner/${partnerId}`);
  return res;
};
export const getAllAboutUsStoryParagraphView = async (partnerId) => {
  const res = await api.get(`/abouteUsStoryPara/getByPartner/${partnerId}`);
  return res;
};
export const getAllAboutUsOverStoryView = async (partnerId) => {
  const res = await api.get(`/abouteUsStorySection/getByPartner/${partnerId}`);
  return res;
};

export const getAllAboutUsTeamView = async (partnerId) => {
  const res = await api.get(`/abouteUsTeamSectionNew/getAllTeamSectionByPartner/${partnerId}`);
  return res;
};
export const getAllTeamParagraphByPartner = async (partnerId) => {
  const res = await api.get(`/abouteUsTeamSection/getAllTeamParagraphByPartner/${partnerId}`);
  return res;
};

export const getAllAboutUsStepCardView = async (partnerId) => {
  const res = await api.get(`/abouteUsStepCard/getByPartner/${partnerId}`);
  return res;
};

export const getAllAboutUsMissionView = async (partnerId) => {
  const res = await api.get(`/abouteUsMission/getAllByPartner/${partnerId}`);
  return res;
};
export const getAllAboutUsBottomView = async (partnerId) => {
  const res = await api.get(`/abouteUsLastTittle/getByPartner/${partnerId}`);
  return res;
};


export const createAboutUsHeader = async (formData) => {
  const res = await api.post(`/abouteUsHeader/create`, formData);
  return res;
};

export const updateAboutUsHeader = async (id,formData) => {
  const res = await api.put(`/abouteUsHeader/update/${id}`, formData);
  return res;
};

export const getAboutUsLastTitle = async (id) => {
  const res = await api.get(`/abouteUsLastTittle/getById/${id}`);
  return res;
};
export const updateAboutUsLastTitle = async (id,formData) => {
  const res = await api.put(`/abouteUsLastTittle/update/${id}`, formData);
  return res;
};
export const createAboutUsLastTitle = async (formData) => {
  const res = await api.post(`/abouteUsLastTittle/create`, formData);
  return res;
};

export const getAboutUsParagraph = async (id) => {
  const res = await api.get(`/abouteUsParagraph/getById/${id}`);
  return res;
};
export const createAboutUsParagraph = async (formData) => {
  const res = await api.post(`/abouteUsParagraph/create`, formData);
  return res;
};

export const updateAboutUsParagraph = async (id,formData) => {
  const res = await api.put(`/abouteUsParagraph/update/${id}`, formData);
  return res;
};
export const getAboutUsOSPara = async (id) => {
  const res = await api.get(`/abouteUsStoryPara/getById/${id}`);
  return res;
};
export const createAboutUsOSPara = async (formData) => {
  const res = await api.post(`/abouteUsStoryPara/create`, formData);
  return res;
};
export const updateAboutUsOSPara = async (id,formData) => {
  const res = await api.put(`/abouteUsStoryPara/update/${id}`, formData);
  return res;
};
export const getAboutUsOurStory = async (id) => {
  const res = await api.get(`/abouteUsStorySection/getbyId/${id}`);
  return res;
};
export const createAboutUsOurStory = async (formData) => {
  const res = await api.post(`/abouteUsStorySection/create`, formData);
  return res;
};

export const updateAboutUsOurStory = async (id,formData) => {
  const res = await api.put(`/abouteUsStorySection/update/${id}`, formData);
  return res;
};
export const getAboutUsStepCards = async (id) => {
  const res = await api.get(`/abouteUsStepCard/getById/${id}`);
  return res;
};
export const createAboutUsStepCards = async (formData) => {
  const res = await api.post(`/abouteUsStepCard/create`, formData);
  return res;
};

export const updateAboutUsStepCards = async (id,formData) => {
  const res = await api.put(`/abouteUsStepCard/update/${id}`, formData);
  return res;
};
export const getAboutUsTeam = async (id) => {
  const res = await api.get(`/abouteUsTeamSectionNew/getAllTeamSectionByPartner/${id}`);
  return res;
};
export const updateAboutUsTeam = async (formData) => {
  const res = await api.put(`/abouteUsTeamSection/update/2`, formData);
  return res;
};
export const getAboutUsMission = async (id) => {
  const res = await api.get(`/abouteUsMission/getById/${id}`);
  return res;
};
export const updateAboutUsMission = async (id,formData) => {
  const res = await api.put(`/abouteUsMission/update/${id}`, formData);
  return res;
};

export const createAboutUsMission = async (formData) => {
  const res = await api.post(`/abouteUsMission/create`, formData);
  return res;
};

export const getAboutUsTeamParagraph = async (id) => {
  const res = await api.get(`/abouteUsTeamSection/getByIdTeamParagraph/${id}`);
  return res;
};

export const updateAboutUsTeamParagraph = async (id,formData) => {
  const res = await api.put(
    `/abouteUsTeamSection/updateTeamParagraph/${id}`,formData
  );
  return res;
};
export const createAboutUsTeamParagraph = async (formData) => {
  const res = await api.post(
    `/abouteUsTeamSection/createTeamParagraph`,
    formData
  );
  return res;
};


export const getEmailTemplateSetting = async (id) => {
  const res = await api.get(`/email-template/get-email-template-by-partner/${id}`);
  return res;
};

export const updateEmailTemplateSetting = async (id,formData) => {
  const res = await api.put(`/email-template/update-email-templates/${id}`, formData);
  return res;
};

export const getEmailTemplateSettingById = async (id) => {
  const res = await api.get(`/email-template/get-email-template-by-id/${id}`);
  return res;
};

const adminAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getEligibilityFiles = async (partnerId, params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, String(value));
    }
  });
  const qs = query.toString();
  const res = await api.get(`/eligibility/get-eligibility-files${qs ? `?${qs}` : ""}`, {
    headers: {
      ...adminAuthHeaders(),
      "x-partner-id": String(partnerId),
    },
  });
  return res;
};

export const uploadEligibilityFileAdmin = async (
  partnerId,
  file,
  withHeaders = true,
  welcomeEmailSlug = "welcome-email-for-sftp",
) => {
  const formData = new FormData();
  formData.append("file", file);
  if (welcomeEmailSlug) {
    formData.append("welcome_email_slug", welcomeEmailSlug);
  }
  const res = await api.post(
    `/eligibility/upload-eligibility-file-admin?with_headers=${withHeaders ? "true" : "false"}`,
    formData,
    {
      headers: {
        ...adminAuthHeaders(),
        "x-partner-id": String(partnerId),
        // Let the browser set multipart boundary — do not force Content-Type
      },
    },
  );
  return res;
};

export const getEligibilityFileLogs = async (partnerId, fileId) => {
  const res = await api.get(`/eligibility/get-eligibility-file-logs/${fileId}`, {
    headers: {
      ...adminAuthHeaders(),
      "x-partner-id": String(partnerId),
    },
  });
  return res;
};

export const retryEligibilityFile = async (partnerId, fileId) => {
  const res = await api.post(
    `/eligibility/retry-eligibility-file/${fileId}`,
    {},
    {
      headers: {
        ...adminAuthHeaders(),
        "x-partner-id": String(partnerId),
      },
    },
  );
  return res;
};
